export { default } from './ListItemIcon';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ListItemIcon/index.js
// module id = 834
// module chunks = 2